import { ChangeDetectionStrategy, Component, inject, input, signal, Signal, viewChild } from '@angular/core';
import { SearchService } from '@core/services/search.service';
import { ImpressionTypePipe } from '@shared/tracking/pipes/impression-type.pipe';
import { LoadingDotsComponent } from '@shared/loading-dots/loading-dots.component';
import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import { ProductCardComponent } from '@features/product/product-card/product-card.component';
import { SliderComponent } from '@features/slider/slider/slider.component';
import { ImpressionTrackingDirective } from '@shared/tracking/impression-tracking/impression-tracking.directive';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { ProductDetailViewModel } from '@models/api-search.models';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { map, switchMap, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ActionStatus } from '@models/common.models';

@Component({
    selector: 'app-product-complementary',
    standalone: true,
    imports: [
        ImpressionTypePipe,
        LoadingDotsComponent,
        NgClass,
        NgStyle,
        ProductCardComponent,
        SliderComponent,
        ImpressionTrackingDirective,
        SvgIconComponent,
        TranslateSafePipe,
        NgTemplateOutlet
    ],
    templateUrl: './product-complementary.component.html',
    styleUrl: './product-complementary.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductComplementaryComponent {
    private readonly searchService = inject(SearchService);

    public slider: Signal<SliderComponent | undefined> = viewChild('slider', { read: SliderComponent });
    // why do we need the status signal? to destroy and build again the slider component
    // otherwise the references are not right and the slider navigation doesn't work as expected
    public status = signal<ActionStatus>('idle');
    public complementaryProducts = input<string[] | undefined>([]);

    public products$: Observable<ProductDetailViewModel[]> = toObservable(this.complementaryProducts).pipe(
        tap(() => this.status.set('loading')),
        switchMap(complementaryProducts => this.searchService.getProducts(...(complementaryProducts ?? []))),
        map(result => result.products || []),
        tap(() => this.status.set('idle'))
    );

    public products: Signal<ProductDetailViewModel[]> = toSignal(this.products$, { initialValue: [] });
}
